import { API } from "../store"
import handleCatch from "../lib/catch"

export const setClients = (clients = []) => ({
  type: "CLIENT::SET_CLIENTS",
  data: clients,
})

export const searchedClients = (clients = []) => ({
  type: "CLIENT::SEARCH_CLIENTS",
  data: clients,
})

export const _setEditClient = (data = {}) => ({
  type: "CLIENT::SET",
  data,
})

export const setCreatedClient = createdClient => ({
  type: "USER::SET_CREATED_CLIENT",
  createdClient,
})

export const toggleAddClientDialog = (
  addClientDialogOpen = false,
  editClient
) => ({
  type: "CLIENT::TOGGLE_ADD_CLIENT_DIALOG",
  addClientDialogOpen,
  editClient,
})

export const toggleDeleteClientDialog = (deleteClientDialogOpen = false) => ({
  type: "CLIENT::TOGGLE_DELETE_CLIENT_DIALOG",
  deleteClientDialogOpen,
})
export const toggleCreateProducerDialog = (
  createProducerDialogOpen = false,
  editUser
) => ({
  type: "USER::TOGGLE_CREATE_PRODUCER_DIALOG",
  createProducerDialogOpen,
  editUser,
})

export const createClient = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/clients`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === "client created") {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateClient = (data, clientId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/clients/${clientId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === "client updated") {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteClient = clientId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/clients/${clientId}`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "client removed") {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getClientList = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/clients`)
        .then(response => response.body)
        .then(response => {
          if (response.message === "Clients found") {
            dispatch(setClients(response.result))
            resolve(response.result)
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

// companies logic

export const setClientCompanies = (companies = []) => ({
  type: "CLIENT::SET_CLIENT_COMPANIES",
  data: companies,
})

export const searchedClientCompanies = (clients = []) => ({
  type: "CLIENT::SEARCH_CLIENT_COMPANIES",
  data: clients,
})

export const _setEditClientCompany = (data = {}) => ({
  type: "CLIENT::SET_COMPANY",
  data,
})

export const setCompanyClients = (data = {}) => ({
  type: "CLIENT::SET_COMPANY_CLIENTS",
  data,
})

// export const setCreatedClientCompany = createdClient => ({
//   type: "USER::SET_CREATED_CLIENT",
//   createdClient,
// })

export const toggleAddClientCompanyDialog = (
  addClientCompanyDialogOpen = false,
  editClientCompany
) => ({
  type: "CLIENT::TOGGLE_ADD_CLIENT_COMPANY_DIALOG",
  addClientCompanyDialogOpen,
  editClientCompany,
})

export const setCreatedClientCompany = createdClientCompany => ({
  type: "CLIENT::SET_CREATED_CLIENT_COMPANY",
  createdClientCompany,
})

export const toggleDeleteClientCompanyDialog = (
  deleteClientCompanyDialogOpen = false
) => ({
  type: "CLIENT::TOGGLE_DELETE_CLIENT_COMPANY_DIALOG",
  deleteClientCompanyDialogOpen,
})

export const createClientCompany = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/client_companies`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === "company created") {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateClientCompany = (data, clientId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/client_companies/${clientId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === "company updated") {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteClientCompany = clientId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/client_companies/${clientId}`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "company removed") {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getCompanyClients = companyId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/company_clients/${companyId}`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "clients found") {
              dispatch(setCompanyClients(response.result))
            } else {
              resolve([])
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const getCompaniesByClient = companyId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/clients/${companyId}`)
          .then(response => response.body)
          .then(response => {
            if (response.message === "companies found") {
              // dispatch(setCompanyClients(response.result))
            } else {
              resolve([])
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getClientCompanies = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/client_companies`)
        .then(response => response.body)
        .then(response => {
          if (response.message === "Companies found") {
            dispatch(setClientCompanies(response.result))
            resolve(response.result)
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}
